.ui-tabs {
  display: flex;
  flex-direction: row;
  gap: var(--ui-space-md);
  margin: 0 var(--ui-space-md);
}

.ui-tabs__tab {
  background-color: transparent;
  border: none;
  color: var(--ui-color-gray-7);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--ui-font-size-base);
  font-weight: var(--ui-font-weight-semi-bold);
  gap: var(--ui-space-md);
  margin: 0;
  min-height: 24px;
  min-width: 24px;
  padding: 0;
}

.ui-tabs__tab:not(.ui-tabs__tab--selected):hover {
  color: var(--ui-color-gray-8);
}

.ui-tabs__tab--selected {
  color: var(--ui-color-neutral-white);
  text-decoration-color: var(--ui-color-secondary);
  text-decoration-line: underline;
  text-decoration-thickness: 0.1em;
  text-underline-offset: 6px;
}

.ui-tabs__tab--single {
  line-height: normal; /* same as button */
  text-decoration-color: transparent;
}

.ui-tabs--incentive {
  gap: var(--ui-space-xs);
}

.ui-tabs--incentive .ui-tabs__tab {
  border: 1px solid var(--ui-color-gray-3);
  border-radius: var(--ui-border-radius-md);
  color: var(--ui-color-text);
  font-size: var(--ui-font-size-s);
  padding: var(--ui-space-xs) var(--ui-space-md);
  text-transform: uppercase;
}

.ui-tabs--incentive .ui-tabs__tab:hover {
  border-color: var(--ui-color-gray-9);
  color: var(--ui-color-text);
}

.ui-tabs--incentive .ui-tabs__tab--selected {
  background-color: var(--ui-color-gray-2);
  border-color: var(--ui-color-gray-9);
  color: var(--ui-color-text);
  text-decoration: none;
}
